import type { OutboundMediaTipo } from '@/shared/types/midiaDeSaida';
import { formatMb, MAX_MEDIA_BYTES } from '@/shared/utils/mediaLimits';

import type { ValidacaoDoAnexo } from '../types';

const SUJEITO_DO_LIMITE: Record<OutboundMediaTipo, string> = {
  IMAGE: 'Imagens',
  VIDEO: 'Vídeos',
  AUDIO: 'Áudios',
  DOCUMENT: 'Documentos',
};

/** O número sai do `MAX_MEDIA_BYTES`, que também valida: a mensagem não anuncia outro teto. */
const rotuloDoLimite = (tipo: OutboundMediaTipo): string =>
  `${SUJEITO_DO_LIMITE[tipo]} vão até ${formatMb(MAX_MEDIA_BYTES[tipo])} MB.`;

const TIPO_POR_MIME: Record<string, OutboundMediaTipo> = {
  'image/jpeg': 'IMAGE',
  'image/png': 'IMAGE',
  'application/pdf': 'DOCUMENT',
  'application/msword': 'DOCUMENT',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOCUMENT',
  'application/vnd.ms-excel': 'DOCUMENT',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'DOCUMENT',
  'audio/ogg': 'AUDIO',
  'audio/mpeg': 'AUDIO',
  'audio/mp4': 'AUDIO',
  'video/mp4': 'VIDEO',
};

/** Vai no `accept` do input: o seletor de arquivos já filtra, e a validação confirma. */
export const MIMES_ACEITOS_NO_ANEXO = Object.keys(TIPO_POR_MIME).join(',');

/**
 * O servidor revalida com os bytes (magic bytes no lerInicio): aqui só se poupa a pessoa de subir
 * 100 MB para ouvir que o tipo não serve.
 */
export const validarAnexo = (arquivo: Pick<File, 'type' | 'size'>): ValidacaoDoAnexo => {
  const tipo = TIPO_POR_MIME[arquivo.type];
  if (!tipo) {
    return {
      valido: false,
      mensagem:
        'Tipo de arquivo não aceito. Envie JPEG, PNG, PDF, DOC, DOCX, XLS, XLSX, OGG, MP3, M4A ou MP4.',
    };
  }
  if (arquivo.size <= 0) return { valido: false, mensagem: 'O arquivo está vazio.' };
  if (arquivo.size > MAX_MEDIA_BYTES[tipo]) {
    return { valido: false, mensagem: `Arquivo grande demais. ${rotuloDoLimite(tipo)}` };
  }
  return { valido: true };
};
